import React from "react";
import { ContactInfo, Form, Seo, Title } from "../components";
import { PAGE_SEO } from "../common";
import "./style.css";

export const ContactPage = () => {
  return (
    <>
      <Seo {...PAGE_SEO.contacts} />
      <div className="container page-bottom-spacing">
        <Title
          as="h1"
          title="Contact us"
          text="Send us a message and we will get back to you!"
          mt="var(--page-top-spacing)"
        />
        <div className="contact-page-content">
          <ContactInfo />
          <Form />
        </div>
      </div>
    </>
  );
};
